import { authorizationService } from '@/services/authorization.service'

/**
 * Directive for profile-based access control
 * Usage: v-permission="'ADMIN'" or v-permission="['ADMIN', 'MANAGER']"
 */
export const permission = {
  mounted(el, binding) {
    const { value } = binding
    
    if (!value) {
      console.warn('v-permission directive requires a value')
      return
    }
    
    if (!authorizationService.hasProfile(value)) {
      // Removes the element from the DOM if the user does not have the required profile
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}

/**
 * Directive for access control based on a specific permission
 * Usage: v-has-permission="'write'" or v-has-permission="['read', 'write']"
 */
export const hasPermission = {
  mounted(el, binding) {
    const { value } = binding
    
    if (!value) {
      console.warn('v-has-permission directive requires a value')
      return
    }
    
    const permissions = Array.isArray(value) ? value : [value]
    const hasAllPermissions = permissions.every(permission => 
      authorizationService.hasPermission(permission)
    )
    
    if (!hasAllPermissions) {
      // Removes the element from the DOM if the user does not have all the required permissions
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}
